/** HubSpot `0-2/ib_country_incorporated_reported` values — matches contact-us / book-a-call. */
export const FUNDING_ELIGIBILITY_HUBSPOT_COUNTRY_VALUES = [
  "United States",
  "United Kingdom",
  "Spain",
  "Ireland",
  "Belgium",
  "Sweden",
  "Australia",
  "Netherlands",
  "Denmark",
  "Canada",
  "Germany",
  "New Zealand",
] as const;

export type FundingEligibilityHubSpotCountry =
  (typeof FUNDING_ELIGIBILITY_HUBSPOT_COUNTRY_VALUES)[number];

export interface FundingEligibilityCountryOption {
  value: FundingEligibilityHubSpotCountry;
  label: string;
}

/** Countries for funding eligibility — value is always the HubSpot enum label. */
export const FUNDING_ELIGIBILITY_COUNTRIES: FundingEligibilityCountryOption[] =
  FUNDING_ELIGIBILITY_HUBSPOT_COUNTRY_VALUES.map((value) => ({
    value,
    label: value,
  }));

const HUBSPOT_COUNTRY_VALUE_SET = new Set<string>(
  FUNDING_ELIGIBILITY_HUBSPOT_COUNTRY_VALUES
);

/** Returns the canonical HubSpot country label when the input matches an allowed option. */
export function mapCountryToHubSpotIbCountryIncorporatedReported(
  country: string
): FundingEligibilityHubSpotCountry | undefined {
  const trimmed = country.trim();
  if (!trimmed || !HUBSPOT_COUNTRY_VALUE_SET.has(trimmed)) {
    return undefined;
  }
  return trimmed as FundingEligibilityHubSpotCountry;
}
